<template>
	<div class="link-navigator-iframe-page" :path="path">
		<iframe frameborder="0" :src="p_src"></iframe>
	</div>
</template>

<script>
	export default {
		name: "link-navigator-iframe-page",
		props: {
			path: {},
			src: {},
		},
		data() {
			return {}
		},
		computed: {
			p_src() {
				// https://cn.vuejs.org/?access_token=crm_9681426f-e902-4147-87a7-9c9ce89d62de
				let src = this.src
				const {url, param} = this.$lv.$utils.decodeUrl(src)

				if (!param.access_token) {
					let token = linkToken.getLocalToken();
					if (token.startsWith('bearer ')) {
						token = token.replace('bearer ', '')
					}
					param.access_token = token
				}

				src = this.$lv.$utils.encodeUrl(url, param)
				return src
			},
		},
	}
</script>

<style lang="scss">
	.link-navigator-iframe-page {
		overflow: hidden !important;
	}
</style>